import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import axios from 'axios';
import authService from './services/admin/auth.service';

axios.defaults.baseURL = process.env.REACT_APP_SERVER_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Guard against multiple simultaneous 401s each trying to redirect.
let isRedirectingToLogin = false;

axios.interceptors.response.use(
    res => res,
    async (err) => {
        if (
            !isRedirectingToLogin &&
            err?.response?.status === 401 &&
            err?.response?.data?.require_totp_setup === true &&
            window.location.pathname !== '/login'
        ) {
            isRedirectingToLogin = true;
            // Best-effort logout to clear the jwt cookie. May itself return 401 if
            // checkAuth blocks it — that 401 is suppressed by isRedirectingToLogin.
            try { await authService.logout(); } catch (_) {}
            sessionStorage.setItem('totp_flash', 'Two-factor authentication is now required. Please log in to set it up.');
            // Full reload resets Redux state automatically (no persistence in use).
            window.location.replace('/login');
        }
        return Promise.reject(err);
    }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
